import { computed } from "vue";
import { i18n } from "./../../i18n";
const { t } = i18n.global;

const menuItems = computed(() => [
    {
        slug: "reports",
        path: "/reports",
        name: "Reports",
        label: t("taxhub.pages.menuItems.reports.linkLabel"),
        children: [
            {
                path: "/reports/overview",
                name: "ListReports",
                label: t("taxhub.pages.menuItems.reports.children.overview.linkLabel"),
            },
        ],
    },
    {
        slug: "file-upload",
        path: "/file-upload",
        name: "FileUpload",
        label: t("taxhub.pages.menuItems.dataProvisioning.linkLabel"),
        children: [
            {
                path: "/file-upload/upload",
                name: "FileUploadPage",
                label: t("taxhub.pages.menuItems.dataProvisioning.children.upload.linkLabel"),
            },
            {
                path: "/file-upload/report-release",
                name: "ReportRelease",
                label: t("taxhub.pages.menuItems.dataProvisioning.children.reportRelease.linkLabel"),
            },
        ],
    },
]);

export { menuItems };
